__turbopack_context__.v({
  "attribute": "_7vpG9q_attribute",
  "attributesContainer": "_7vpG9q_attributesContainer",
  "linkAttribute": "_7vpG9q_linkAttribute",
});
